/* global gtag */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowCallDialog } from "../../../../redux/slices/SearchBarSlice";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Button } from "reactstrap";
import { getAllMessages, sendMessage } from "../../Data";
import { useSocket } from "../../../../contexts/SocketContext";

const CallDialog = () => {
  const { sendNewMessage } = useSocket();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const { showCallDialog, sampleAd } = useSelector((state) => state.searchBar);
  const { selectedConvo } = useSelector((state) => state.messages);
  const dispatch = useDispatch();
  const isProd = process.env.REACT_APP_PRODUCTION === "true";
  const formatPhoneNumber = (phone) => {
    if (!phone || phone.length !== 10) return phone; // Ensure valid 10-digit number
    return `(${phone.slice(0, 3)})${phone.slice(3, 6)}-${phone.slice(6)}`;
  };
  const fetchParent = async () => {
    if (sampleAd?.createdBy) {
      const req = {
        customerId: +sampleAd?.createdBy,
        needId: sampleAd?.Id || sampleAd?.id,
        createdBy: user.UserID, // Use updated userId
      };
      const response = await getAllMessages(req);
      const filterParent = response.filter((msg) => msg.parentId == 0);
      await MessageSend(filterParent[0]);
    }
  };
  const handleCallNow = () => {
    window.location.href = `tel:${
      sampleAd?.Phone || sampleAd?.phone || sampleAd?.profilePhone
    }`;
    if (isProd && window.dataLayer) {
      window.dataLayer.push({
        event: "phone_call_initiated",
        method: "click_to_call",
        ad_id: sampleAd?.id || sampleAd?.Id,
      });
    }
    dispatch(setShowCallDialog(false));
  };
  const MessageSend = async (parent) => {
    const navUrl = `${process.env.REACT_APP_URL}/#/userDetails/${user.UserID}`;
    const fullName = [user?.FirstName, user?.LastName]
      .filter(Boolean)
      .join(" ")
      .trim();
    const description = `Hello from MySikhCommunity.com, ${fullName} contacted you just now <a className="text-primary" href="${navUrl}" target="_blank" rel="noopener noreferrer">Click to view user →</a>.`;
    const messageForm = {
      customerId: sampleAd?.createdBy || "0",
      postId: sampleAd?.Id || "0",
      postType: 1,
      Description: description,
      messageStatus: 8,
      createdBy: user.UserID, // Use updated userId
      roleId: user.RoleId, // Use role from login response if needed
      ownerId: sampleAd?.createdBy || "0",
      userName: user.FirstName + " " + user.LastName, // Use first name from fullName
      Email: user.Email,
      serviceNeed: "service",
      parentId: !selectedConvo
        ? parent
          ? parent.Id
          : 0
        : selectedConvo.parentId === 0
        ? selectedConvo.Id
        : selectedConvo.parentId ?? 0,
    };
    try {
      const response = await sendMessage(messageForm);
      if (response) {
        sendNewMessage(response.Data);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };
  const handleCloseCallDialog = () => {
    dispatch(setShowCallDialog(false));
  };
  const handleBackdropClick = (event) => {
    event.stopPropagation();
  };
  useEffect(() => {
    if (showCallDialog) {
      fetchParent();
    }
  }, [showCallDialog]);
  return (
    <Dialog
      open={showCallDialog}
      onClose={handleCloseCallDialog}
      aria-labelledby="call-dialog-title"
      PaperProps={{
        sx: {
          background: "linear-gradient(135deg, #ff4d4d, #cc0000)",
          color: "#fff",
          borderRadius: "16px",
          padding: "8px 4px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
          width: "100%",
          maxWidth: "500px",
        },
      }}
      BackdropProps={{
        onClick: handleBackdropClick,
        sx: { backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(2px)" },
      }}
    >
      <DialogTitle
        id="call-dialog-title"
        sx={{
          fontSize: "1.4rem",
          textAlign: "center",
          fontWeight: 700,
          paddingBottom: 1,
        }}
      >
        Call User
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", paddingBottom: 0 }}>
        <div
          style={{
            fontWeight: 600,
            fontSize: "1.15rem",
            marginTop: "8px",
            background: "rgba(255,255,255,0.15)",
            padding: "12px",
            borderRadius: "12px",
            letterSpacing: "0.5px",
          }}
        >
          Call this poster now:
          <div
            style={{
              fontSize: "1.35rem",
              marginTop: "6px",
              fontWeight: 700,
              textShadow: "0 1px 3px rgba(0,0,0,0.2)",
            }}
          >
            {formatPhoneNumber(
              sampleAd?.post_phone ||
                sampleAd?.phone ||
                sampleAd?.profilePhone ||
                sampleAd?.Phone
            )}
          </div>
        </div>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          paddingBottom: 2,
          marginTop: 2,
        }}
      >
        <button
          onClick={handleCallNow}
          style={{
            backgroundColor: "#ffffff",
            color: "#47781aff",
            fontWeight: "bold",
            borderRadius: "5px",
            padding: "5px 24px",
          }}
        >
          📞 Call Now
        </button>

        <button
          onClick={handleCloseCallDialog}
          style={{
            color: "#ffffff",
            backgroundColor: "#989898ff",
            borderWidth: "2px",
            fontWeight: "bold",
            borderRadius: "5px",
            padding: "5px 24px",
          }}
        >
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default CallDialog;
